export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Ako',
  frontPageProvideTitle: 'May Kaya',
  frontPagePersonalCenterTitle: 'Profile',
  login: 'Mag-login',
  home_chatWithOctopie: 'Iniintindi ang mga iniisip mo',
  home_chatNeedUnderstood: 'Naiintindihan na ang mga iniisip mo',
  home_draftBannerTitle: 'Tapusin ang mensahe mo',
  home_draftBannerSubtitle: 'Naayos na ng AI ang mensahe mo — i-tap para magpatuloy',
  home_tabHome: 'Home',

  // App.vue
  appRequirementTitle: 'Pinapakinggan namin ang bawat mungkahi at puna',
  appRequirementBtn: 'Ipadala',
  appSubmitSuccess: 'Naipadala nang matagumpay, salamat sa iyong puna',
  appFeedbackLink: 'Mungkahi/Puna',
  mobile_banner_text: 'Para sa pinakamahusay na karanasan, gamitin ang aming app',
  mobile_banner_btn: 'Kunin ang App',

  // Common
  loading: 'Naglo-load...',
  confirm: 'Kumpirmahin',
  cancel: 'Kanselahin',
  save: 'I-save',
  delete: 'Burahin',
  edit: 'I-edit',
  add: 'Magdagdag',
  search: 'Maghanap',
  refresh: 'I-refresh',
  change_batch: 'Palitan ang batch',
  back: 'Bumalik',
  submit: 'Ipadala',
  close: 'Isara',
  ok: 'Sige',
  yes: 'Oo',
  no: 'Hindi',
  send: 'Ipadala',
  block: 'I-block',
  more: 'Higit pa',
  logout: 'Mag-logout',
  settings: 'Mga Setting',
  view_guide: 'Tingnan ang gabay',
  feedback: 'Puna',
  feedback_title: 'Puna',
  feedback_new: 'Bagong puna',
  feedback_empty: 'Wala pang puna',
  feedback_hint: 'Sabihin ang iyong iniisip...',
  feedback_submit: 'Ipadala',
  feedback_submit_success: 'Matagumpay na naipadala ang puna',
  feedback_submit_failed: 'Hindi naipadala ang puna',
  feedback_reply_label: 'Sagot ng platform',
  register: 'Magparehistro',
  name: 'Pangalan',
  email: 'Email',
  mobile: 'Mobile number',
  password: 'Password',
  verification_code: 'Verification code',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Lahat ng karapatan ay nakalaan.',
  footerVersion: 'Bersyon {version}',
  copy: 'Kopyahin',
  regenerate: 'Muling gawin',
  generate: 'Gawin',
  contact_now: 'Makipag-chat',
  yours: 'ikaw',
  xiaoyao_analysis: 'Pagsusuri ng AI',
  brand_name: 'OctoSay',
  anonymous: 'Di-kilalang tao',
  no_summary: 'Walang buod',
  file: 'File',
  discover: 'Tuklasin',
  discover_title: 'Tuklasin',
  discover_hotChannels: 'Mga sikat na channel',
  discover_allChannels: 'Lahat',
  discover_searchChannel: 'Maghanap ng channel',
  discover_noChannels: 'Walang nahanap na channel',

  // Messages
  operationSuccess: 'Tagumpay ang operasyon',
  operationFailed: 'Hindi nagtagumpay ang operasyon',
  networkError: 'Error sa network, subukan muli mamaya',
  dataLoadingFailed: 'Hindi na-load ang data',
  noData: 'Walang data',
  deleteConfirm: 'Sigurado ka bang buburahin ito?',
  saveConfirm: 'Sigurado ka bang i-se-save ito?',

  // Form Validation
  required: 'Kailangan punan ang field na ito',
  emailInvalid: 'Maglagay ng wastong email address',
  phoneInvalid: 'Maglagay ng wastong numero ng telepono',
  passwordTooShort: 'Dapat hindi bababa sa {min} karakter ang password',
  passwordMismatch: 'Magkaiba ang dalawang password na nilagay mo',

  // Time
  today: 'Ngayon',
  yesterday: 'Kahapon',
  justNow: 'Ngayon lang',
  minutesAgo: '{min} minuto ang nakalipas',
  hoursAgo: '{hour} oras ang nakalipas',
  daysAgo: '{day} araw ang nakalipas',

  // Footer
  about: 'Tungkol',
  footerPrivacy: 'Patakaran sa Privacy',
  footerTerms: 'Mga Tuntunin ng Serbisyo',
  footerSupport: 'Tulong at suporta',

  // Register
  registerAgeConfirm: 'Kinukumpirma kong ako ay 13 taong gulang pataas',
  registerAgeConfirm18: 'Kinukumpirma ko na ako ay 18 taong gulang pataas',
  registerTermsPrefix: 'Nabasa ko na at sumasang-ayon ako sa ',
  registerTermsAnd: ' at ',
  registerAgeError: 'Pakikumpirma ang iyong edad',
  registerTermsError: 'Pakitanggap ang mga tuntunin at patakaran sa privacy',

  // Chat
  chatPrivacyTip: 'Isulat sa hub ang gusto mong sabihin, mag-uusap muna ang AI sa iyo para linawin ang mga detalye. Kapag nakumpirma mo na, sabay na maipapadala ang iyong mensahe at ang AI summary, at patuloy kang tutulungan ni AI makahanap ng match.',
  aiChat_quickSuggestions: 'Subukang sabihin',
  aiChat_welcome: "Uy! Sabihin mo kung ano ang hinahanap mo.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Naiintindihan na ang mga detalye — kumpirmahin para mag-post at makahanap ng match',
  aiChat_readyToPostHint: 'Patuloy na makikipag-chat para kahit kailan makapagdagdag ng detalye o ma-update ang buod',
  aiChat_progressStep1: 'Intindihin ang mga detalye',
  aiChat_progressStep1Done: 'Naiintindihan na ang mga detalye',
  aiChat_progressStep2: 'AI summary',
  aiChat_progressStep2Desc: "Gumagawa si AI ng summary para sa matching",
  aiChat_progressStep3: 'I-post sa Grupo',
  aiChat_progressStep3Desc: 'I-post at hanapin ang iyong match',
  aiChat_publishExtraHint: 'Ilagay ang gusto mong sabihin sa mga miyembro ng hub',
  aiChat_publishMsgRequired: 'Kailangan',
  aiChat_publishMsgLabel: 'Gusto mong sabihin sa mga miyembro ng hub',
  aiChat_matchSummaryLabel: 'AI summary',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'Ang sumusunod na nilalaman ay gawa ng AI at para sanggunian lamang.',
  aiChat_publishSuggestionHint: 'I-tap para palitan',
  aiChat_allowDirectContact: 'Payagan ang direktang pagkontak',
  aiChat_allowDirectContactDesc: 'Maaaring direktang kontakin ka ng iba kahit walang match',
  channel_chat_session_publishToChannel: 'I-post sa Grupo ng Octo',
  aiChat_newChat: 'I-reset',

  // Channels / Mga Grupo
  home_tabChannels: 'Mga Grupo ng Octo',
  channels_title: 'Mga Grupo ng Octo',
  channels_myChannels: 'Mga sinalihang hub',
  channels_discover: 'Tuklasin',
  channels_noChannels: 'Wala pang hub',
  channels_noMyGroupsTitle: 'Wala ka pang sinalihang hub',
  channels_noMyGroupsSubtitle: 'Maghanap ng hub na sasalihan at magsimulang makakilala ng mga bagong kaibigan',
  channels_searchGroupsBtn: 'Maghanap ng hub',
  channels_loginPrompt: 'Mag-login para makita ang mga hub',
  channels_create: 'Gumawa ng Grupo ng Octo',
  channels_search: 'Maghanap ng Grupo ng Octo',
  channels_searchMyGroups: 'Maghanap sa mga Grupo ng Octo ko',
  channels_searchHint: 'Maghanap',
  channels_searchHintChats: 'Maghanap sa mga chat...',
  channels_searchHintGroups: 'Maghanap ng hub...',
  channels_searchHintMy: 'Maghanap sa mga sinalihang hub...',
  channels_joinByCode: 'Sumali gamit ang code',
  channels_joinByCodeTitle: 'Sumali sa Grupo ng Octo gamit ang code',
  channels_joinByCodeHint: 'Ilagay ang Grupo ng Octo code',
  channels_joinByCodeConfirm: 'Sumali',
  channels_joinByCodeNotFound: 'Hindi nahanap ang hub',
  channels_createNewGroup: 'Gumawa ng bagong Grupo ng Octo',
  channels_noResults: 'Walang nahanap na hub',
  channel_detail_join: 'Sumali',
  channel_detail_leave: 'Umalis',
  channel_detail_members: 'miyembro',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: 'sumali si {name}',
  channelJoinMsg_twoJoined: 'sumali sina {name1} at {name2}',
  channelJoinMsg_multiJoined: 'sumali sina {name1}, {name2} at {n} pa',
  channelJoinMsg_oneAndMoreJoined: 'sumali si {name} at {n} pa',
  channelJoinMsg_membersJoined: 'sumali ang {n} miyembro',

  // Feed
  channels_feed: 'Mga chat',
  channels_groups: 'Mga Hub',
  feed_related: 'Kaugnay',
  feed_recommend: 'Inirerekomenda',
  feed_empty: 'Wala pang laman, tignan muna ang mga sikat na hub',
  feed_goToGroup: 'Tingnan sa hub',
  feed_joinGroupAndSendMsg: 'Sumali sa hub at magpadala ng mensahe',
  channel_detail_channelCode: 'Grupo ng Octo code',
  channel_detail_invitePhrase: 'Imbitasyon sumali sa "{name}"\nInvitation code {code} — buksan ang app para awtomatikong sumali · Lilinawin muna ng AI ang detalye bago hanapin ang tamang tao',
  channel_detail_post: 'I-post sa Grupo',
  channel_detail_aiHint: "I-type ang iyong mensahe sa hub at lilinawin muna ni AI ang mga detalye",
  channel_input_hint: 'Sabihin ang gusto mong sabihin...',
  channel_leave_confirm_message: 'Sigurado ka bang aalis ka sa hub na ito? Hindi ka na makakatanggap ng mga mensahe mula sa hub.',
  channel_invite_notFound: 'Hindi umiiral ang hub o expired na ang link',
  channel_invite_joinBtn: 'I-download ang OctoSay app',
  channel_invite_hint: 'I-download ang app, pagkatapos ay i-scan ang QR code na ito o hanapin ang pangalan ng hub para sumali',
  channel_invite_globalHintTitle: 'Iginagawad ang pag-download ng global version',
  channel_invite_globalHintIOS: 'Posibleng hindi available ang app na ito sa App Store ng China. Lumipat sa Apple Store na nasa labas ng China at hanapin ang OctoSay, o i-download nang direkta ang APK sa ibaba.',
  channel_invite_globalHintAndroid: 'Posibleng hindi ma-access ang Google Play sa iyong rehiyon. Inirerekomenda naming i-download nang direkta ang APK, o subukan ang Google Play.',
  channel_invite_globalHintDefault: 'Posibleng hindi available ang app sa lokal na app store. Inirerekomenda naming i-download nang direkta ang APK, o subukan ang App Store.',
  channel_invite_globalBtnAppStore: 'Punta sa App Store',
  channel_invite_globalBtnGooglePlay: 'Punta sa Google Play',
  channel_invite_globalBtnAPK: 'Direktang i-download ang APK',
  channel_invite_defaultDesc: 'Sumali sa {name} sa OctoSay',
  share: 'Ibahagi',
  share_channel: 'Ibahagi ang hub',
  share_channel_link: 'Ibahagi ang link',
  channel_detail_inviteCode: 'Invite code',
  channel_detail_copyLink: 'Kopyahin ang link',
  share_session_title: 'Isang post sa OctoSay',
  share_match_title: 'Isang match sa OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Tingnan kung ano ang ipinost ni {userName} sa OctoSay',
  session_share_notFound: 'Hindi umiiral ang post o expired na ang link',
  session_share_fromChannel: 'Mula sa Grupo ng Octo',
  session_share_downloadBtn: 'I-download ang OctoSay app',
  session_share_hint: 'I-download ang app para makita ang buong post at sumali sa hub',
  session_share_openInApp: 'Buksan sa app',
  toast_link_copied: 'Nakopya ang link',
  toast_no_share_data: 'Walang maibabahagi',
  channels_joinByQR: 'QR code',
  channels_joinByQRWebHint: 'Hindi pa suportado ang pag-scan ng QR sa web. Maglagay ng hub code para sumali.',
  channels_joinByQRTitle: 'Sumali gamit ang QR code',
  channel_detail_qrCode: 'QR code',
  channel_detail_qrCodeSave: 'I-save ang larawan',
  channel_detail_qrCodeSaveHint: 'I-right click ang larawan para i-save',
  channel_detail_qrCodeSaved: 'Nai-save sa album',
  channel_detail_qrCodeSaveFailed: 'Hindi na-save, subukan muli',
  channel_detail_locateFailed: 'Hindi nahanap ang mensahe',
  channel_detail_locateError: 'Error sa paghahanap ng mensahe',
  channel_detail_myMessages: 'Mga mensahe ko',
  channel_detail_searchMessages: 'Maghanap sa mga mensahe',
  channel_detail_aiChat: 'Usapan kasama si AI',
  channel_detail_matchHistory: 'Kasaysayan ng pagmamatch',
  channel_create_title: 'Gumawa ng Grupo ng Octo',
  channel_create_name: 'Pangalan ng Grupo ng Octo',
  channel_create_description: 'Paglalarawan',
  channel_create_submit: 'Gumawa',
  channelCreate_aiAssist: 'Tutulungan ka ni AIng gumawa ng hub na angkop sa iyo',
  channelCreate_nameHint: 'Maglagay ng pangalan para sa hub mo',
  channelCreate_descHint: 'Ilarawan kung ano ang tungkol sa hub mo',
  channelCreate_creating: 'Ginagawa...',
  channelCreate_created: 'Nagawa ang hub!',
  channelCreate_failed: 'Hindi nagawa ang hub',
  channelCreate_welcomeMsg: "Hi! Nandito ako para tulungan kang gumawa ng hub. Sabihin mo kung anong klaseng hub ang gusto mo — ang pangalan, paksa, o layunin — at tutulungan kitang gawin itong pangalan ng hub at intro ng hub, kasama na ang profile picture.",
  channelCreate_aiHint: 'Isulat ang tema ng hub mo...',
  channelCreate_clarifyingProgress: 'Inaayos ang tema ng hub mo...',
  channelCreate_readyToCreate: 'Handa nang gumawa ng Grupo ng Octo',
  channelCreate_step1: 'Ilarawan ang tema',
  channelCreate_step1Done: 'Malinaw na ang ideya',
  channelCreate_step2: 'Gumawa ng Grupo ng Octo',
  channelCreate_confirmBtn: 'Kumpirmahin ang paggawa',
  channelCreate_publicNotice: "Ang mga hub ay public na espasyo kung saan nagtitipon at nagkukonekta ang mga taong may magkatulad na interes. Maaaring i-manage, i-update, o pagsamahin ng platform ang mga hub kung kinakailangan. Ibahagi lang ang hub na ito sa iba na maaaring interesado.",
  channelCreate_similarGroupsTitle: 'May nahanap na katulad na Grupo ng Octo',
  channelCreate_similarGroupsDesc: 'Maaaring angkop sa iyo ang mga hub na ito',
  channelCreate_exactMatchHint: 'May hub nang may eksaktong ganitong pangalan!',
  channelCreate_joinHint: 'Maaaring angkop sa iyo ang mga umiiral na hub na ito',
  channelCreate_joinExisting: 'Sumali sa umiiral na Grupo ng Octo',
  channelCreate_stillCreate: 'Gumawa pa rin ng bagong Grupo ng Octo',
  channel_chat_session_comments: 'Mga komento',
  channel_chat_session_commentHint: 'Sumulat ng komento...',
  channel_chat_session_sendComment: 'Komento',
  channel_chat_session_loadMore: 'Mag-load pa',
  channel_chat_session_noComments: 'Wala pang komento',
  channel_chat_session_deleteComment: 'Burahin',
  channelSearch_title: 'Maghanap sa Grupo',
  channelSearch_placeholder: 'Maghanap sa mga mensahe...',
  channelSearch_onlyMine: 'Mga post ko lang',
  channelSearch_tabAllMessages: 'Mga mensahe ng hub',
  channelSearch_tabMyMessages: 'Mga mensahe ko',
  chatMsgSearch_placeholder: 'Maghanap sa mga mensahe',
  chatMsgSearch_tabMsgs: 'Mga mensahe',
  chatMsgSearch_tabContacts: 'Mga contact',
  chatMsgSearch_emptyPrompt: 'Maglagay ng keyword para maghanap ng mensahe',
  chatMsgSearch_tooShort: 'Maglagay ng kahit 2 karakter bago maghanap',
  chatMsgSearch_contactEmptyPrompt: 'Maglagay ng username o email para maghanap ng contact',
  chatMsgSearch_noContacts: 'Walang nahanap na contact',
  chatMsgSearch_inChatPlaceholder: 'Maghanap sa chat na ito',
  channelHistory_title: 'Kasaysayan',
  channelHistory_myMessages: 'Mga mensahe ko',
  channelHistory_loadMore: 'Mag-load pa',
  channel_settings_push: 'Mga notification ng Grupo ng Octo',
  channel_settings_commentPush: 'Mga notification ng komento',
  channel_settings_likePush: 'Mga notification ng like',
  channel_settings_receiveNotifications: 'Tumanggap ng notification',
  channel_settings_directContact: 'Payagan ang direktang pagkontak',
  session_published: 'Naipost na',
  session_publishFailed: 'Hindi naipost',
  session_setDirectContactSuccess: 'Na-save ang setting',
  session_setDirectContactFailed: 'Hindi na-save ang setting',
  session_setPrivate: 'Gawing pribado',
  session_setPublic: 'Gawing pampubliko',
  session_pauseMatching: 'I-pause ang pagtutugma',
  session_resumeMatching: 'I-resume ang pagtutugma',
  session_matchPausedToast: 'Naka-pause ang pagtutugma',
  session_matchResumedToast: 'Ipinagpatuloy ang pagtutugma',
  match_matchingPausedTitle: 'Naka-pause ang pagtutugma',
  match_reasonTag: 'Dahilan ng pagtutugma',
  match_matchingPausedHint: 'Maaari mong i-resume ang pagtutugma anumang oras.',
  session_confirmSetPrivate: 'Gagawing pribado ang content na ito? Hindi na makikita ng ibang user.',
  session_messageIsPrivate: 'Pribadong mensahe ito',
  chatSessionComment_replyHint: 'Sumulat ng komento...',
  chatSessionComment_reply: 'Komento',
  chatSessionComment_count: '{n} komento',
  chatSessionMatch_count: '{n} match',
  chatSessionComment_replyTo: 'Sumagot',
  chatSessionComment_inputHint: 'Sumulat ng komento...',
  chatSessionComment_send: 'Ipadala',
  chatSessionComment_delete: 'Burahin',
  chatSessionComment_deleteConfirm: 'Sigurado ka bang buburahin ang komentong ito?',
  chatSessionComment_loadMore: 'Mag-load pa',
  chatSessionComment_noMore: 'Wala nang iba pang komento',
  chatSessionComment_loginToComment: 'Mag-login para makapagkomento',
  chatSessionComment_viewEarlier: 'Tingnan ang {n} naunang sagot',
  chatSessionLike_like: 'Like',
  chatSessionLike_liked: 'Nagustuhan',
  chatSessionLike_count: 'like',
  chatSessionBookmark_bookmark: 'I-bookmark',
  chatSessionBookmark_bookmarked: 'Naka-bookmark',
  chatSessionMatch_viewMatches: 'Tingnan ang mga match',
  chatSessionMatch_matchHistory: 'Kasaysayan ng pagmamatch',
  chatSessionMatch_noMatches: 'Wala pang match',
  channel_match_achievement: '{count} ang post na matagumpay na na-match',
  channel_match_achievement_view: 'Tingnan →',
  channel_matchHistory_title: 'Kasaysayan ng pagmamatch ng channel',
  chatSessionMatch_matchedAt: 'Na-match noong {time}',
  discover_userMsgLabel: 'Sabi ng user',
  common_loading: 'Naglo-load...',
  common_sending: 'Ipinapadala...',
  common_error: 'May mali',
  common_success: 'Tagumpay',
  common_me: 'Ako',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "Nililinaw ng AI ang kailangan mo para tumalab ang bawat mensahe mong i-post; pagkatapos i-post, magpapatuloy ito sa paghahanap ng match",
  aiChat_clarifyingAlmostDone: 'Malapit nang matapos, pakikumpirma',
  aiChat_clarifyingOneMore: 'Tatlong tanong na lang halos, makakapag-post ka na',
  aiChat_clarifyingRemaining: 'May natitirang mga {count} round pa, malapit nang matapos',
  aiChat_clarifyingEvaluating: 'Sinusuri ang progreso...',
  aiChat_setPublicMatch: 'Gawing pampubliko at i-match',
  aiChat_needsClarifiedPublic: "Naiintindihan na kita. Kapag kinumpirma at ipinost mo, patuloy kang hahanapan ni AI ng match.\nMaaari kang magbahagi ng higit pang detalye kahit kailan.",
  aiChat_needsClarifiedPrivate: 'Naiintindihan na kita! Gawing pampubliko para patuloy akong makahanap ng match para sa iyo!\nSabihin mo sa akin ang mga detalye kahit kailan.',
  aiChat_setPublicTitle: 'Gawing pampubliko',
  aiChat_setPublicMessage: 'Makikita ng ibang tao ang content mo para makahanap si OctoSay ng mga katugmang match para sa iyo.\n\nAng ibabahaging impormasyon:\n• Username at profile picture mo\n• Buod ng content mo\n• Nilalaman ng pag-uusap (makikita sa Tuklasin)\n\nMaaari mo itong gawing pribado ulit kahit kailan.',
  aiChat_findMatches: 'Tingnan ang resulta ng match',
  aiChat_publishing: 'Nagpo-post...',
  aiChat_matchSectionTitle: 'Ang mensahe mo ay pinakabagay sa mga grupong ito — i-tap para i-post',
  aiChat_joinedBadge: 'Miembro na',
  aiChat_matchSectionEmpty: 'Wala pang tugma na grupo — pwede kang gumawa ng bagong grupo at i-post doon',
  aiChat_suggestPublishCreateNew: 'Gumawa ng bagong grupo',
  aiChat_repickChannel: 'Palitan ang grupo',
  aiChat_creatingChannelTitle: 'Walang angkop na grupo — gumagawa ng isa para sa iyo',
  aiChat_creatingChannelHint: 'Gumagawa ang AI ng grupo ayon sa iyong kahilingan, pagkatapos ay diretsong magpo-post ka — karaniwang 10-30 segundo',
  aiChat_publishToChannelHint: 'Ipo-post sa "{name}"',
  aiChat_pickChannelTitle: 'Piliin ang grupong ipo-post',
  aiChat_matchingChannelTitle: 'Naghahanap ng tamang grupo para sa iyo',
  aiChat_matchingChannelHint: 'Naghahanap ang AI batay sa iyong kahilingan — karaniwang ilang segundo hanggang kalahating minuto',
  aiChat_matchUnavailableTitle: 'Hindi available ang mga rekomendasyon',
  aiChat_matchUnavailableHint: 'Maghanap ng grupo sa ibaba, o isara at buksan muli ang pag-post',
  aiChat_waitSlowHint: 'Mas mabagal kaysa karaniwan pero nagpapatuloy pa rin — maghintay sandali, o maghanap ng grupo sa ibaba',
  aiChat_creatingSlowHint: 'Mas mabagal ang paggawa ng grupo kaysa karaniwan pero tuloy pa rin — pagkatapos ay diretsong magpo-post ka',
  aiChat_pickChannelEmptyHint: 'Walang nahanap na kaugnay na grupo. Gumawa ng bagong grupo para i-post ang mensahe mo',
  aiChat_loadMore: 'Mag-load Pa',
  sidebar_publish: 'I-post',
  chat_selectLocationOnMap: 'Pumili ng lokasyon sa mapa',

  // App.vue new
  placeholder_email: 'Maglagay ng email',
  placeholder_mobile: 'Maglagay ng mobile number',
  placeholder_password: 'Maglagay ng password',
  placeholder_name: 'Maglagay ng pangalan mo',
  random_nickname: 'Random',
  placeholder_verification_code: 'Maglagay ng verification code',
  sending: 'Ipinapadala...',
  registering: 'Nagpaparehistro...',
  send_code: 'Ipadala ang code',
  retry_in_seconds: 'Subukan muli sa {countdown}s',
  toast_enter_email: 'Maglagay ng email',
  toast_enter_mobile: 'Maglagay ng mobile number',
  toast_invalid_email: 'Maglagay ng wastong email format',
  toast_invalid_mobile: 'Maglagay ng wastong mobile number',
  toast_send_code_failed: 'Hindi naipadala ang verification code',
  toast_code_sent: 'Naipadala ang verification code sa email',
  toast_code_sent_sms: 'Naipadala ang verification code sa mobile',
  toast_send_code_error: 'Hindi naipadala ang verification code, subukan muli mamaya',
  toast_fill_all_fields: 'Punan ang lahat ng field',
  toast_login_failed: 'Hindi nakapag-login',
  toast_login_success: 'Matagumpay na nakapag-login',
  oauthOr: 'o',
  toast_oauth_login_failed: 'Hindi nakapag-login sa Google',
  toast_oauth_login_error: 'May mali sa pag-login sa Google, subukan muli',
  toast_login_error: 'Hindi nakapag-login, subukan muli mamaya',
  toast_register_failed: 'Hindi nakapagparehistro',
  toast_register_success: 'Matagumpay na nakapagparehistro',
  toast_register_error: 'Hindi nakapagparehistro, subukan muli mamaya',

  // AdBanner.vue
  ad: 'Ad',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Bago mag-connect',
  contactAd_gateSubtitle: 'Ang maikling pahinga na ito ang nagpapanatiling libre ang OctoSay — salamat sa suporta!',
  contactAd_waitBtn: 'Magpatuloy pagkatapos ng {sec}s',
  contactAd_continueBtn: 'Magpatuloy sa chat',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Chat',

  // AiMatch.vue
  ai_welcome_msg: 'Kumusta, ako si AI. Sabihin mo kung ano ang nasa isip mo — kasa-mangahan, partner, palitan ng skills, o KAHIT ANO.',
  default_username: 'User',

  // AvatarCropDialog.vue
  crop_hint: 'I-pinch para mag-zoom, i-drag para i-adjust',
  toast_crop_failed: 'Hindi na-crop ang larawan',

  // ChatBox.vue
  loading_match_info: 'Nilo-load ang match info...',
  view_match_details: 'Tingnan ang detalye ng match',
  step_clarify_needs: 'Ilinaw',
  step_ai_matching: 'I-post sa Grupo',
  step_connect: 'AI matching',
  make_private: 'Gawing pribado',
  setting: 'Sine-set...',
  action_photo: 'Larawan',
  action_file: 'File',
  action_video: 'Video',
  action_location: 'Lokasyon',
  hint_get_app: 'Kunin ang app para manatiling konektado',
  match_finding_title: 'Mga match mo',
  match_finding_subtitle: 'Patuloy na naghahanap si AI ng mga match para sa iyo',
  match_time_hint: 'Kadalasan ay tumatagal ito ng 1-2 minuto',
  match_result_stats: 'Nakahanap ng {matched} na pinakamahusay na match{interested}',
  match_tap_to_connect: 'I-tap para simulan ang usapan ninyo',
  match_channel_hint: 'Nagmi-match sa hub na <strong>#{channel}</strong>. Pinaprioridad ang mga match sa parehong hub, pero maaaring kasama ang ibang hub kung kailangan.',
  label_perfect_match: 'Pinakamahusay na match',
  label_worth_a_look: 'Bisitahin',
  match_no_result_title: 'Patuloy na naghahanap ng match para sa iyo',
  match_no_result_desc: 'Magbahagi pa ng detalye para matulungan si OctoSay na makahanap ng mga tamang match. I-install ang app para makatanggap ng notification kapag may nagmatch sa iyo.',
  go_back: 'Bumalik',
  no_public_requirements: 'Wala pang pampublikong post',
  channelEmpty_title: 'Tahimik pa rito',
  channelEmpty_subtitle: 'Ikaw ang unang magbahagi ng iyong mga saloobin',
  channelEmpty_hint: "Isulat ang mga ideya mo at tutulungan ka ni AI na linawin at patuloy na mag-match, para hindi malimutan ang mensahe mo",
  channelEmpty_action: 'Ibahagi ang mga saloobin mo',
  stay_connected: 'Manatiling konektado',
  download_app_desc: 'Kunin ang app para makapag-chat at makatanggap agad ng notification kapag may nagkontak sa iyo!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'Direktang APK',
  match_history: 'Kasaysayan ng pagmamatch',
  no_match_history: 'Wala pang kasaysayan ng pagmamatch',
  finding_matches: 'Patuloy na naghahanap si AI ng mga match - Pagkatapos mag-post ng mensahe sa hub',
  discover_connect_hint: 'Makakapag-chat ka sa kanila kapag nagmatch na!',
  match_initializing: 'Sinisimulan...',
  placeholder_login_to_chat: 'mag-login para sabihin sa akin ang nasa isip mo',
  toast_need_clear: 'Malinaw na ang ideya mo!',
  toast_ai_responding: 'Sumasagot si AI, sandali lang...',
  toast_uploading_image: 'Ina-upload ang larawan, sandali lang...',
  toast_uploading_file: 'Ina-upload ang file, sandali lang...',
  toast_max_photos: 'Hanggang {max} larawan lang',
  toast_uploading: 'Ina-upload, sandali lang...',
  toast_file_too_large: 'Lampas sa 5MB limitasyon ang {name}',
  toast_video_too_large: 'Lampas sa 20MB limitasyon ang {name}',
  toast_video_processing: 'Pinoproseso ang video, sandali lang…',
  toast_upload_link_failed: 'Hindi nakuha ang upload link',
  analyzing_image: 'Sinusuri ang larawan...',
  toast_location_confirmed: 'Kinumpirma ang lokasyon',
  toast_location_selected: 'Napili ang lokasyon',
  toast_enter_search: 'Maglagay ng hinahanap',
  toast_search_failed: 'Nabigo ang paghahanap',
  toast_no_locations: 'Walang nahanap na lokasyon',
  toast_search_error: 'Nabigo ang paghahanap, subukan muli',
  toast_located_at: 'Nahanap sa: {address}',
  toast_shared_finding: 'Naibahagi! Naghahanap ng mga match...',
  toast_update_failed: 'Hindi na-update',
  toast_set_private: 'Naging pribado na',
  toast_no_matches: 'Walang nahanap na match',
  toast_matches_found: 'Nakahanap ng {count} na pinakamahusay na match',
  toast_start_conversation_first: 'Simulan muna ang usapan',
  toast_load_history_failed: 'Hindi na-load ang kasaysayan ng pagmamatch',
  toast_ai_timeout: 'Nag-time out si AI, subukan muli',
  toast_message_blocked: 'Na-block ang mensahe',
  network_disconnected: 'Nadiskonekta ang network',
  toast_publish_success: 'Naipost sa hub!',
  toast_publish_failed: 'Hindi naipost sa hub',

  // ChatMsgList.vue
  collapse_thinking: 'ikabit ang proseso ng pag-iisip',
  expand_thinking: 'ilabas ang proseso ng pag-iisip',
  thinking: 'nagiisip',
  select_date: 'Pumili ng petsa',
  selected_location: 'Napiling lokasyon',
  msg_blocked: 'Na-block',
  retry: 'Subukan muli',
  msg_read: 'Nabasa na',
  msg_sent: 'Naipadala',
  msg_unread: 'Hindi pa nababasa',
  label_start_datetime: 'Petsa at oras ng pagsisimula:',
  label_end_datetime: 'Petsa at oras ng pagtatapos:',
  toast_select_start_datetime: 'Pumili ng petsa at oras ng pagsisimula',
  toast_end_before_start: 'Hindi puwedeng mas maaga ang oras ng pagtatapos kaysa sa pagsisimula',
  report_message: 'I-report ang mensahe',
  block_user: 'I-block ang user',
  msg_revoke: 'Bawiin',
  msg_quote: 'Quote',
  msg_revoked_self: 'Binawi mo ang isang mensahe',
  msg_revoked_other: 'Binawi ng kabila ang isang mensahe',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Binawi ang mensahe',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Binawi ng platform ang mensaheng ito dahil sa paglabag',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Nabawi ang mensahe',
  toast_revoke_failed: 'Hindi nabawi ang mensahe',
  toast_load_data_failed: 'Hindi na-load ang data, i-refresh at subukan muli.',
  toast_file_url_missing: 'Walang nahanap na file URL',
  toast_block_success: 'Matagumpay na na-block ang user',
  toast_block_failed: 'Hindi ma-block ang user',

  // ChatSession.vue
  no_more_records: 'wala nang iba pang tala.',
  title_needs_clarified: 'Malinaw na ang mga ideya',
  title_clarifying: 'Nililinaw ang mga ideya mo',
  title_public: 'Pampubliko',
  title_private: 'Pribado',
  badge_clarified: 'Nailinaw',
  badge_clarifying: 'Inililinaw',
  badge_only_me: 'Ako lang',
  badge_expired: 'Expired',
  title_expired: 'Expired',
  no_chat_history: 'Walang chat history',

  // ContactMethods.vue
  block_status_banner: 'Naka-block mo ang user na ito',
  unblock_user: 'I-unblock',
  toast_block_missing_id: 'Hindi ma-block: walang user ID',
  dialog_block_confirm: 'Sigurado ka bang ibe-block si {name}? Hindi ka na makakatanggap ng mga mensahe mula sa kanya.',
  toast_user_blocked: 'Naka-block si {name}',
  toast_unblock_missing_id: 'Hindi ma-unblock: walang user ID',
  toast_user_unblocked: 'Na-unblock si {name}',

  // BlockedUsers.vue
  blocked_users: 'Mga naka-block na user',
  blocked_users_empty: 'Walang naka-block na user',
  blocked_users_empty_hint: 'Hindi na makakapagpadala ng mensahe sa iyo ang mga user na na-block mo',
  blocked_users_unblock: 'I-unblock',
  dialog_unblock_confirm: 'Kapag na-unblock na, makakapagpadala na ulit siya ng mensahe sa iyo.',
  toast_unblock_success: 'Na-unblock na',
  toast_unblock_failed: 'Hindi ma-unblock, subukan muli',
  blocked_users_load_failed: 'Hindi na-load. I-tap para subukan muli',
  blocked_users_blocked_at: 'Naka-block noong {date}',
  blocked_users_unknown_user: 'Di-kilalang user',

  // Contacts.vue
  no_connections: 'Wala pang mensahe',
  chat_with: 'Makipag-chat kay {name}',
  toast_load_contacts_failed: 'Hindi na-load ang mga contact: {msg}',
  toast_load_contacts_error: 'Hindi na-load ang mga contact. Paki-refresh at subukan muli.',
  time_just_now: 'Ngayon lang',
  time_minutes_ago: '{min}m ang nakalipas',
  time_hours_ago: '{hour}h ang nakalipas',
  time_days_ago: '{day}d ang nakalipas',

  // InteractionNotification.vue
  interaction_notification_title: 'Mga notification',
  interaction_notification_subtitle: 'Mga komento at like',
  interaction_notification_empty: 'Wala pang notification',
  interaction_notification_comment: 'nagkomento: {content}',
  interaction_notification_like: 'nagustuhan ang post mo',
  interaction_notification_reply: 'sumagot: {content}',
  interaction_notification_bookmark: 'naka-bookmark ng post mo',
  toast_load_notifications_failed: 'Hindi na-load ang mga notification: {msg}',
  toast_load_notifications_error: 'Hindi na-load ang mga notification. Paki-refresh at subukan muli.',
  mark_all_read: 'Markahang nabasa lahat',
  toast_mark_all_read_failed: 'Nabigo ang operasyon, subukan muli',
  contacts_dnd: 'I-mute ang mga notification',
  dnd_enabled: 'Na-mute ang mga notification',
  dnd_disabled: 'Na-unmute ang mga notification',
  dnd_action_enable: 'I-mute ang mga notification',
  dnd_action_disable: 'I-unmute ang mga notification',

  // Discover.vue
  toast_load_sessions_failed: 'Hindi na-load ang mga session: {msg}',
  toast_load_sessions_error: 'Hindi na-load ang mga session',
  discover_noMessages: 'Wala pang mensahe',

  // EmojiInputArea.vue
  placeholder_default: 'Magbahagi pa ng detalye kay AI',
  userChat_typeMessage: 'Sumulat ng mensahe...',
  select_emoji: 'Pumili ng emoji',
  badge_new: 'bago',
  channel_search_placeholder: 'Maglagay ng channel',
  channel_picker_empty: 'Maglagay ng channel',

  // FrontPage.vue
  tab_chat_with_ai: 'Pakinggan ka ng OctoSay',
  history_chats: 'Kasaysayan',
  tab_connections: 'Mga match',
  tab_conversations: 'Mga mensahe',
  tab_profile: 'Profile',
  new_session: 'Bago',
  history_tab_chats: 'Akin',
  history_tab_matches: 'Mga match',
  channels_octosay: 'Mga Grupo ng Octo',
  tab_matches: 'Mga match',
  tab_messages: 'Mga mensahe',

  // Header.vue
  slogan: 'OctoSay - Ang AI na nakakaintindi sa iyo at hinahanap ang taong para sa iyo',
  app_name: 'OctoSay',
  slogan_short: 'Ang AI na nakakaintindi sa iyo at hinahanap ang taong para sa iyo',
  slogan_ai: 'Ang AI na nakakaintindi sa iyo at hinahanap ang taong para sa iyo',
  get_the_app: 'Kunin ang app',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'o hanapin ang OctoSay sa mga app store',

  // MapLocationPicker.vue
  placeholder_search_location: 'Maghanap ng lokasyon...',
  coords_display: 'Longitude: {lng}, Latitude: {lat}',
  toast_no_geolocation: 'Hindi suportado ng browser mo ang geolocation',
  toast_location_permission_denied: 'Hindi makuha ang iyong lokasyon, pakitingnan ang pahintulot sa lokasyon',
  loading_address: 'Nilo-load ang address...',

  // MatchedSession.vue
  created_at: 'Nagawa: {time}',
  ai_match_analysis: 'Pagsusuri ni AI sa match',
  error_missing_session_params: 'May kulang na kinakailangang session parameter',
  match_private_hint: 'Pribado ang session na ito. Hindi makikita ang nilalaman',

  // PersonalCenter.vue
  label_name: 'Pangalan:',
  placeholder_enter_name: 'Maglagay ng pangalan mo',
  label_bio: 'Bio:',
  placeholder_enter_bio: 'Sumulat ng ilang bagay tungkol sa iyo',
  placeholder_bio_empty: 'Magbahagi ng ilang bagay tungkol sa iyo',
  bio: 'Bio',
  delete_account: 'Burahin ang account',
  delete_warning: 'Hindi na maibabalik ang pagkilos na ito.',
  delete_data_intro: 'Permanenteng buburahin ang sumusunod na data:',
  delete_item_profile: 'Impormasyon ng profile mo',
  delete_item_chat: 'Chat history at mga session',
  delete_item_contact: 'Impormasyon ng mga contact',
  delete_item_all: 'Lahat ng kaugnay na data',
  final_confirmation: 'Panghuling kumpirmasyon',
  delete_confirm_prompt: 'I-type ang "delete" para kumpirmahin:',
  placeholder_type_delete: 'I-type ang delete',
  private_token: 'Pribadong token',
  token_desc: 'Gumawa ng token para sa API access',
  toast_not_logged_in: 'Hindi naka-login ang user',
  toast_name_required: 'Kailangan ang pangalan',
  toast_save_success: 'Matagumpay na na-save',
  toast_save_failed: 'Hindi na-save',
  toast_image_too_large: 'Lampas sa 5MB limitasyon ang larawan',
  toast_avatar_updated: 'Na-update ang profile picture',
  toast_avatar_failed: 'Hindi ma-update ang profile picture',
  toast_upload_failed: 'Hindi na-upload',
  toast_token_generated: 'Nagawa ang token',
  toast_token_failed: 'Hindi magawa ang token',
  toast_copied: 'Nakopya sa clipboard',
  toast_copy_failed: 'Hindi nakopya',
  toast_account_deleted: 'Matagumpay na nabura ang account',
  toast_delete_account_failed: 'Hindi nabura ang account',
  toast_logout_success: 'Matagumpay na nakapag-logout',
  toast_logout_failed: 'Hindi nakapag-logout',
  profile_tab_messages: 'Mga mensahe',
  profile_tab_comments: 'Mga komento',
  profile_tab_likes: 'Mga like',
  profile_tab_bookmarks: 'Mga naka-bookmark',
  profile_empty_messages: 'Wala pang naipost na mensahe',
  profile_empty_comments: 'Wala pang komento',
  profile_empty_likes: 'Wala pang like',
  profile_empty_bookmarks: 'Wala pang naka-bookmark',
  profile_reply_to: 'Sumagot kay {name}',
  profile_stats_posts: 'Mga mensahe',
  profile_stats_comments: 'Mga komento',
  profile_stats_likes: 'Mga natanggap na like',
  profile_joined: 'Sumali noong {date}',

  // ReportDialog.vue
  report_message_title: 'I-report ang mensahe',
  report_reason_prompt: 'Piliin ang dahilan ng pag-report sa mensaheng ito:',
  report_spam: 'Spam',
  report_harassment: 'Pang-aapi o panunugot',
  report_inappropriate: 'Hindi angkop na nilalaman',
  report_other: 'Iba pa',
  placeholder_report_desc: 'Ilarawan ang problema (opsyonal)',
  toast_select_reason: 'Pumili ng dahilan',
  toast_report_success: 'Matagumpay na naipadala ang report',
  toast_report_failed: 'Hindi naipadala ang report',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Larawan]',
  summary_images: '[Larawan x{count}]',
  summary_file: '[File]',
  summary_files: '[File x{count}]',
  summary_video: '[Video]',
  summary_videos: '[Video x{count}]',
  summary_location: '[Lokasyon]',
  summary_locations: '[Lokasyon x{count}]',
  summary_emoji: '[Emoji]',
  summary_emojis: '[Emoji x{count}]',
  summary_voice: '[Voice message]',
  summary_voices: '[Voice message x{count}]',
  summary_mixed: '[Halo-halo]',
  summary_other: '[Iba pa]',

  // Voice messages
  voice: 'Voice message',
  voice_recording: 'Nagre-record...',
  toast_voice_too_short: 'Masyadong maikli ang recording',
  toast_voice_failed: 'Hindi naipadala ang voice message',
  toast_mic_permission_denied: 'Hindi ma-access ang mikropono. Paki-enable sa browser settings',
  toast_recording_not_supported: 'Hindi sinusuportahan ng browser na ito ang pag-record ng boses',
  voice_load_failed: 'Hindi na-load ang voice message',

  // Expire At
  aiChat_expireLine: "Bisa hanggang {date}, sabihin lang kay AI kahit kailan para i-update",
  aiChat_expireExpired: "Nag-expire na ang nilalaman at hindi na nakikita ng iba. Sabihin lang kay AI kahit kailan para i-update ang expiration",

  // MatchedSession.vue
  detail: 'Detalye',

  // Match notification hints
  match_new_result_hint: 'Kapag may bagong resulta ng match, makakatanggap ka ng email notification. Para sa mas mahusay na karanasan, i-install ang app para sa instant na notification.',

  // Match notification hints
  match_connection_notify_hint: 'Nagmatch at nabigyang-alam na! Bilisan mo, batiin mo na siya!',
  match_continuousMatching: "Patuloy kang hinahanapan ni AI ng match",
  match_continuousMatchingHint: 'Agad kaming magpapabalita kapag may natagpuang bagong match',
  match_continuousMatchingOthers: "Patuloy silang hinahanapan ni AI ng match",
  match_continuousMatchingOthersHint: 'Dito lalabas ang mga bagong match kapag natagpuan na',
  match_noResultsTitleOthers: 'Patuloy na naghahanap ng match para sa kanya',
  match_noResultsHintOthers: "Patuloy silang hinahanapan ni AI ng match. Lalabas dito ang mga resulta kapag natagpuan.",
  match_newMatchFound: 'May {n} bagong match na natagpuan!',
  match_worth_exploring_hint: 'Ikaw ang magdedesisyon kung uunahin mong kontakin siya.',

  // Matches filter tags
  filter_all: 'Lahat',
  filter_best_connection: 'Pinakamahusay na match',
  filter_worth_a_look: 'Bisitahin',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - Ang AI na nakakaintindi sa iyo at hinahanap ang taong para sa iyo',
  landing_hero_title: 'Sumulat sa hub mo — ililinaw muna ni AI, kapag kinumpirma mo ay sasabay na ang buod sa pag-post',
  landing_hero_subtitle: 'Isulat sa Grupo ng Octo ang gusto mong sabihin. Bago mailathala, mag-uusap muna si AI sa iyo para linawin ang mga detalye. Kapag kinumpirma mo na, sabay na maipapadala ang orihinal na mensahe mo at ang match summary sa hub, at patuloy na hahanapan ka ni AI ng pinakaangkop na tao',
  landing_download_on: 'I-download sa',
  landing_get_it_on: 'Kunin sa',
  landing_direct_download: 'Direktang i-download',
  landing_how_title: 'Tatlong hakbang',
  landing_step1_title: 'Sumulat ng mensahe sa hub',
  landing_step1_desc: 'Isulat sa hub ang gusto mong iparating. Hindi agad maipapadala ang mensahe, mag-uusap muna si AI sa iyo para linawin ang mga detalye, para sa bawat mensahe ay malinaw, kapaki-pakinabang at karapat-dapat sa pagmamatch — hindi malunod sa magulong chat.',
  landing_step2_title: 'Kumpirmahin bago i-post at magmatch',
  landing_step2_desc: 'Kapag nakumpirma mo na, sabay na maipapadala sa hub ang orihinal na mensahe mo at ang match summary. Sunod, patuloy na hahanapin ni AI ang pinakaangkop na tao para sa iyo, para hindi malunod ang mensahe mo na parang walang nakakakita.',
  landing_step3_title: 'Pagkatapos ng match, natural na pag-uusapan',
  landing_step3_desc: 'Matapos magmatch, makikita ng parehong panig ang chat history nila kay AI at ang match summary. Kapag magkatugma ang konteksto, natural lang ang pagbabreak the ice at mas kumportableng mag-usap.',
  // Comparison Section
  landing_comparison_title: 'Bakit OctoSay?',
  landing_comparison_subtitle: 'Grupo-style na chat, pero tinutulungan ka ni AIng linawin ang detalye at aktibong nagmamatmulan sa pagitan ninyo.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Kalidad ng nilalaman',
  landing_cmp1_other: 'Ad, kalat at mga mensaheng labas sa paksa ang dumadaan',
  landing_cmp1_octo: 'Mga kard ng kailangan lang ang ipinapakita na na-filter ng AI',
  landing_cmp2_label: 'Paghahanap ng tao',
  landing_cmp2_other: 'Mag-post tapos magdasal na may makakita',
  landing_cmp2_octo: 'Aktibong nagmamatch si AI ng mga taong para sa iyo',
  landing_cmp3_label: 'Antas ng ingay',
  landing_cmp3_other: 'Daan-daang mensahe ang i-sa-scroll',
  landing_cmp3_octo: 'Zero na ingay, may kahulugan ang bawat mensahe',
  landing_cmp4_label: 'Gaan ng pagsisimula',
  landing_cmp4_other: 'Maghanap ng server, mag-browse ng channel, kusang matuto',
  landing_cmp4_octo: 'Sumulat lang sa hub, at si AI ang maglilinaw at magmamatch',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Bumabaha ng ad at kalat sa group chat',
  landing_cmp1_xhs: 'Daming marketing post, mahirap malaman kung alin ang totoo',
  landing_cmp1_facebook: 'Nagbabaha ang ad at clickbait sa feed',
  landing_cmp1_reddit: 'Spam at mga post na labas sa paksa kahit saan',
  landing_cmp2_wechat: 'Umaasa lang sa contact list at pag-imbita sa grupo',
  landing_cmp2_xhs: 'Kailangang maghanap ka mag-isa at unti-unting maghanap',
  landing_cmp2_facebook: 'Limitado lang sa mga kaibigan at grupo na meron ka na',
  landing_cmp2_reddit: 'Ikaw ang mag-b-browse ng subreddit at mags-asam ng sagot',
  landing_cmp3_wechat: 'Daan-daang group message ang i-scroll',
  landing_cmp3_xhs: 'Puro recommendation at ad ang feed',
  landing_cmp3_facebook: 'Hindi matapos-tapos na recommended post at ad',
  landing_cmp3_reddit: 'Daan-daang komento ang i-scroll',
  landing_cmp5_label: 'Sino ang naghahanap',
  landing_cmp5_wechat: 'Isa-isang magtanong, pagtataya ng swerte',
  landing_cmp5_xhs: 'Magpost, maghintay ng komento, at kusang mag-sala',
  landing_cmp5_facebook: 'Kailangan mong magtanong dito at doon sa grupo',
  landing_cmp5_reddit: 'Magpost, maghintay ng sagot, pagkatapos mag-sala',
  landing_cmp5_octo: 'Ang AI ang tuloy-tuloy at awtomatikong maghahanap ng tao para sa iyo',

  landing_features_title: 'Pangunahing tampok',
  landing_feature1_title: 'Ilawan bago i-post',
  landing_feature1_desc: 'Walang pupunuang form. Isulat sa hub ang gusto mong sabihin, at mag-uusap muna si AI sa iyo bago i-post, magtatanong ng mga tamang detalye, para talagang maunawaan ang kailangan mo',
  landing_feature2_title: 'Pagmamatch ng Grupo ng Octo',
  landing_feature2_desc: 'Sabay na maipapadala sa Grupo ng Octo ang mensahe mo at ang match summary, at tuloy-tuloy na hahanapan ka ni OctoSay ng sagot o taong makaka-relate sa iyo mula sa mga miyembro ng hub, at sasabihin kung bakit angkop sa iyo',
  landing_feature3_title: 'Proaktibong pagmamatch',
  landing_feature3_desc: 'Kapag nakumpirma mo na at nailathala ang mensahe at match summary mo, tuloy-tuloy na maghahanap si AI sa hub ng mga taong tugma sa hinahanap mo, walang kailangang maghanap o mag-scroll',
  landing_feature4_title: 'Komunidad ng Grupo ng Octo',
  landing_feature4_desc: 'Sumali sa mga Grupo ng Octo na interesado ka para makakuha ng sagot, makahanap ng makakasama, para mas natural at mas may init ang pagkakakonekta',
  landing_feature5_title: 'Proteksyon sa privacy',
  landing_feature5_desc: 'Pagkatapos magpadala, maaari mong gawing pribado na ikaw lang ang makakakita, ganap mong napapamahalaan ang impormasyon mo',
  landing_feature6_title: 'Epektibong komunikasyon',
  landing_feature6_desc: 'Walang ingay, walang nakakagambalang mensahe, may kahulugan ang bawat mensahe',
  landing_usecases_title: 'Para sa anumang sitwasyon',
  landing_usecases_subtitle: 'Anuman ang gusto mo o kailangan mo, naiintindihan at matutulungan ka ni AI',
  landing_usecase_game: 'Kasama sa laro',
  landing_usecase_language: 'Palitan ng wika',
  landing_usecase_skill: 'Palitan ng skills',
  landing_usecase_roommate: 'Maghanap ng kasama sa bahay',
  landing_usecase_travel: 'Kasama sa biyahe',
  landing_usecase_sports: 'Kasama sa sports',
  landing_usecase_study: 'Kasama sa pag-aaral',
  landing_usecase_anything: '...o magbahagi ng kahit ano',
  landing_cta_title: 'Handa ka na ba?',
  landing_cta_desc: 'Sumali sa Grupo ng Octo, isulat ang gusto mong sabihin, ilinaw muna ni AI, kumpirmahin mo bago i-post, at tuloy na tutulungan ka nitong hanapin ang tamang tao. Simulan na ngayon.',
  landing_use_now: 'Gamitin ngayon',
  landing_groups: 'Grupo ng Octo',

  // OnboardingPage.vue
  onboarding_skip: 'Laktawan',
  onboarding_next: 'Susunod',
  onboarding_getStarted: 'Magsimula',
  onboarding_step1Title: "Sabihin sa hub kung ano ang gusto mo",
  onboarding_step1Desc: "Anuman ang hinahanap mo o gusto mong gawin, sabihin lang. Kakausapin ka ng AI para linawin ang mga detalye at gawin itong malinaw na mensahe.",
  onboarding_step2Title: 'Kumpirmahin bago i-post at magmatch',
  onboarding_step2Desc: "Kapag nai-post na sa hub ang mensahe mo, patuloy na maghahanap ang AI ng pinakamahusay na match para sa iyo, kaya hindi mabaon o mapabayaan ang msg mo.",
  onboarding_step3Title: 'Pagkatapos ng match, natural na pag-uusapan',
  onboarding_step3Desc: "Kitang-kita ng magkabilang panig ang pinag-usapan ng bawat isa kay AI at kung ano ang hinahanap nito. Sa shared context, madali lang makipag-usap — mag-chat lang nang natural.",

  // ChannelDetail.vue
  channel_image_limit: 'Isang larawan lang',

  // ChannelMembers.vue
  channel_members_empty: 'Wala pang miyembro',
  channel_members_title: 'Mga miyembro',
  channel_role_owner: 'May-ari',
  channel_role_admin: 'Admin',
  channel_role_member: 'Miyembro',

  // Settings.vue
  settings_language: 'Wika',
  settings_language_followSystem: 'Sundan ang sistema',

  // ChatBox.vue
  match_interested_suffix: ', {count} na sulit tingnan',

  // ChatBox.vue - Mga yugto ng AI matching progress
  match_stage_fetch_chat: 'Kinukuha ang usapan',
  match_stage_query_expansion: 'Pinalalawak ang mga query',
  match_stage_semantic_search: 'Semantic na paghahanap',
  match_stage_deep_search: 'Malalim na pagsusuri',
  match_stage_rerank: 'Smart na pagtutugma',
  match_stage_refining: 'Ino-optimize ang mga resulta',
  match_stage_fetch_details: 'Kinukuha ang mga detalye',

  // ChannelDetail.vue - Pag-upload ng larawan
  channel_select_image: 'Mangyaring pumili ng file ng larawan',
  channel_image_upload_failed: 'Nabigo ang pag-upload ng larawan, pakisubukan muli',
  chatInput_channelSearchHint: "Maghanap ng grupo",
}



// WEBPACK FOOTER //
// ./src/i18n/fil.js